import {truish} from 'quickstart/types'
import {ReactNode} from 'react'
import S from './styles.module.scss'

export const LeftRight = ({
  children: [left, right],
}: {
  children: [ReactNode, ReactNode]
}) => (
  <div className={S.wrapper}>
    <div className={S.left}>{left}</div>
    {truish(right) && <div className={S.right}>{right}</div>}
  </div>
)
